"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@mui/material/styles");
const styled_components_1 = __importDefault(require("styled-components"));
const common_buoy_theme_1 = require("@buoyhealth/common.buoy-theme");
const BaseButton_1 = __importDefault(require("../BaseButton"));
const StyledButton = (0, styled_components_1.default)(BaseButton_1.default) `
  width: 100%;
  height: 100%;

  background-color: ${({ theme }) => theme.palette.common.white};
  padding: 27px 16px;
  border-radius: 4px;
  border: solid 1px ${({ theme }) => theme.palette.gray[30]};
  position: relative;
  min-height: 64px;
  min-width: 64px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &.Mui-focusVisible {
    border-color: white;
  }

  &.Mui-focusVisible:before {
    content: "";
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    box-shadow: ${({ theme }) => theme.constants.focusBoxShadow};
    border-radius: 4px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.common.white};
    border-color: transparent;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
  }

  &:active {
    background-color: ${({ theme }) => theme.palette.common.white};
    border-color: ${({ theme }) => theme.palette.gray[30]};
    box-shadow: none;
  }

  &.Mui-disabled:disabled {
    pointer-events: auto;
    box-shadow: none;
    opacity: 0.4;
    border-color: ${({ theme }) => theme.palette.gray[30]};
  }
`;
const StyledSvgWrapper = styled_components_1.default.div `
  > svg {
    height: 64px;
    max-width: 100%;
    max-height: 100%;
  }
`;
const StyledOptionTitle = styled_components_1.default.div `
  margin-top: 11px;
  ${({ theme }) => theme.typography.variants.primary.main};
  white-space: nowrap;

  ${(0, common_buoy_theme_1.mobileFirstResponsive)({
    field: "font-size",
    values: {
        sm: "18px",
        xs: "16px",
    },
})}
`;
/**
 * _Tile Button_
 *
 * The tile button contains information and is used to guide an action to another page.
 * It includes a descriptive image and header.
 *
 * NOTE: The header must not exceed 2 sentences
 *
 * All tiles are designed to be responsive for screen sizes.
 * They must always align to the layout grid.
 *
 * */
const TileButton = ({ IllustrationSvg, displayText, ...rest }) => ((0, jsx_runtime_1.jsxs)(StyledButton, { touchRippleColor: (0, styles_1.useTheme)().palette.gray[0], ...rest, children: [(0, jsx_runtime_1.jsx)(StyledSvgWrapper, { children: IllustrationSvg }), (0, jsx_runtime_1.jsx)(StyledOptionTitle, { children: displayText })] }));
exports.default = TileButton;
//# sourceMappingURL=index.js.map